
import { defineComponent } from 'vue'
import { iOutputColumn } from '../../FunctionsCatalog'
import Dropdown from 'primevue/dropdown'
import functionsCatalogOutputTabDescriptor from './FunctionsCatalogOutputTabDescriptor.json'

export default defineComponent({
    name: 'function-catalog-input-column',
    components: { Dropdown },
    props: { column: { type: Object }, readonly: { type: Boolean } },
    emits: ['deleted'],
    data() {
        return {
            functionsCatalogOutputTabDescriptor,
            outputColumn: {} as iOutputColumn
        }
    },
    watch: {
        column() {
            this.loadColumn()
        }
    },
    created() {
        this.loadColumn()
    },
    methods: {
        loadColumn() {
            this.outputColumn = this.column as iOutputColumn
        },
        onFieldTypeChange() {
            this.outputColumn.type = ''
        },
        getColumnTypes() {
            return this.outputColumn.type === 'ATTRIBUTE' ? this.functionsCatalogOutputTabDescriptor.columnTypes : { value: 'NUMBER' }
        },
        deleteColumnConfirm() {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.$emit('deleted')
            })
        }
    }
})
